import React from 'react'

import {
  Box,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'

import { WEEKLY_REPORTS_USER_TABLE_HEAD } from 'src/constants/table.constants'

interface WeeklyReportsTableRowProps {
  entriesInfo: TimeEntries[]
  openEntries: boolean
}

const nestLevel2 = {
  mx: 2,
  mt: 1,
  mb: 1.5,
  borderRadius: 2,
  overflow: 'hidden',
  border: (theme: { palette: { divider: string } }) =>
    `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme: {
    palette: {
      mode: string
      grey: { 500_12: string }
      background: { neutral: string }
    }
  }) =>
    theme.palette.mode === 'dark'
      ? theme.palette.grey[500_12]
      : theme.palette.background.neutral
}

const WeeklyReportUserTable: React.FC<WeeklyReportsTableRowProps> = ({
  entriesInfo,
  openEntries
}) => (
  <>
    {openEntries && !!entriesInfo?.length && (
      <Fade in={openEntries}>
        <Box sx={nestLevel2}>
          <Table size="small" aria-label="work type details">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'dark'
                      ? theme.palette.grey[700]
                      : theme.palette.grey[300]
                }}
              >
                {WEEKLY_REPORTS_USER_TABLE_HEAD.map((head) => (
                  <TableCell
                    key={head.id}
                    align={head.align}
                    width={head.width}
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.8125rem',
                      py: 1,
                      borderBottom: (theme) =>
                        `1px solid ${theme.palette.divider}`
                    }}
                  >
                    {head.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {entriesInfo?.map((entry, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:hover': {
                      backgroundColor: (theme) => theme.palette.action.hover
                    }
                  }}
                >
                  <TableCell sx={{ py: 1 }}>{entry?.workType}</TableCell>
                  <TableCell sx={{ py: 1 }}>{entry?.description}</TableCell>
                  <TableCell align="right" sx={{ py: 1 }}>
                    {entry?.time}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Fade>
    )}
  </>
)

export default WeeklyReportUserTable
